












































import { defineComponent, inject, computed, ref } from '@vue/composition-api'

import { ConversationStatusType, EntityType, ProjectFormType } from '@/api/project/model'
import { allEntityTypeItems } from '@/api/project/entity-type-option'
import VideoDialog from '@/components/VideoDialog.vue'
import TestGroupStatus from './components/TestGroupStatus.vue'

export default defineComponent({
    components: {
        VideoDialog,
        TestGroupStatus
    },
    setup(props, {root, emit }) {
        const itemInfo: any = inject('itemInfo')
        const messageInfo = computed(() => {
            const { entity_type } = itemInfo.message_entity
            const entityTypeOption = allEntityTypeItems.find((v) => v.value == entity_type)
            return {
                name: entityTypeOption?.label,
                icon: entityTypeOption?.icon
            }
        })
        const videoDialogRef = ref()
        const showVideoDialog = (url: string) => {
            if (url) {
                videoDialogRef.value.open(url)
            }
        }

        return {
            ConversationStatusType,
            EntityType,
            ProjectFormType,
            itemInfo,
            messageInfo,
            videoDialogRef,
            showVideoDialog
        }
    }
})
